import React, { useEffect, useState } from "react";
import { Card } from "primereact/card";
import { Button } from "primereact/button";
import { Dropdown } from "primereact/dropdown";
import { InputText } from "primereact/inputtext";
import { FileUpload } from "primereact/fileupload";
import { Message } from "primereact/message";
import { ProgressSpinner } from "primereact/progressspinner";

import { ChergementEtudiantsService } from "../service/ChergementEtudiantsService";
import { UniversiteService } from "../service/UniversiteService";
import { EtablissementService } from "../service/EtablissementService";
import { DepartementService } from "../service/DepartementService";
import { ParcoursService } from "../service/ParcoursService";
import { NiveauService } from "../service/NiveauService";
import { AnneeAcademiqueService } from "../service/AnneeAcademiqueService";

function ChargementEtudiants() {
  const [formData, setFormData] = useState({
    idUniversite: null,
    idEtablissement: null,
    idDepartement: null,
    idParcours: null,
    idNiveau: null,
    idAnneeAcademique: null,
    libelleDiplome: "",
  });

  const [nomFichier, setNomFichier] = useState(null);
  const [fileBase64, setFileBase64] = useState(null);
  const [status, setStatus] = useState(null);
  const [loading, setLoading] = useState(false);
  const [loadingData, setLoadingData] = useState(true);

  const [universites, setUniversites] = useState([]);
  const [etablissements, setEtablissements] = useState([]);
  const [departements, setDepartements] = useState([]);
  const [parcours, setParcours] = useState([]);
  const [niveaux, setNiveaux] = useState([]);
  const [annees, setAnnees] = useState([]);

  const chargementService = new ChergementEtudiantsService()
  const univService = new UniversiteService()
  const etabService = new EtablissementService()
  const deptService = new DepartementService()
  const parsService = new ParcoursService()
  const nivService = new NiveauService()
  const annService = new AnneeAcademiqueService()

  let codeIesr = localStorage.getItem("codeIesr")
  let role_admin = localStorage.getItem("admin_secure")
  let role_univ = localStorage.getItem("univ_secure")
  role_admin = JSON.parse(role_admin)
  role_univ = JSON.parse(role_univ)
  codeIesr = JSON.parse(codeIesr)
  
  useEffect(() => {
    if(role_admin) {
      
      const fetchInitialData = async () => {
      try {
        const [univData, anneeData] = await Promise.all([
          univService.getUniversites(),
          annService.getAnneesAcademiques(),
        ]);
        setUniversites(univData);
        setAnnees(anneeData);
      } catch (err) {
        setStatus({ type: "error", message: "Erreur lors du chargement initial." });
      } finally {
        setLoadingData(false);
      }
    };
    fetchInitialData();
    }
    else if(role_univ){
       const fetchInitialData = async () => {
      try {
        const [anneeData] = await Promise.all([
          annService.getAnneesAcademiques()
        ]);
        setAnnees(anneeData);
        setFormData({ ...formData, idUniversite: codeIesr });
      } catch (err) {
        setStatus({ type: "error", message: "Erreur lors du chargement initial." });
      } finally {
        setLoadingData(false);
      }
    };
    fetchInitialData();
    }
    else;
    
  }, []);

  useEffect(() => {
    if (!formData.idUniversite) return;
    setEtablissements([]);
    setDepartements([]);
    setParcours([]);
    setNiveaux([]);
    setFormData((prev) => ({
      ...prev,
      idEtablissement: null,
      idDepartement: null,
      idParcours: null,
      idNiveau: null,
    }));

    const fetchEtablissements = async () => {
      const data = await etabService.getEtablissementsByUniversite(formData.idUniversite);
      setEtablissements(data);
    };
    fetchEtablissements();
  }, [formData.idUniversite]);

  useEffect(() => {
    if (!formData.idEtablissement) return;
    setDepartements([]);
    setParcours([]);
    setNiveaux([]);
    setFormData((prev) => ({
      ...prev,
      idDepartement: null,
      idParcours: null,
      idNiveau: null,
    }));

    const fetchDepartements = async () => {
      const data = await deptService.getDepartementsByEtablissement(formData.idEtablissement);
      setDepartements(data);
    };
    fetchDepartements();
  }, [formData.idEtablissement]);

  useEffect(() => {
    if (!formData.idDepartement) return;
    setParcours([]);
    setNiveaux([]);
    setFormData((prev) => ({
      ...prev,
      idParcours: null,
      idNiveau: null,
    }));

    
    const fetchParcours = async () => {
      const data = await parsService.getParcoursByDepartement(formData.idDepartement);
      setParcours(data);
    };
    fetchParcours();
  }, [formData.idDepartement]);

  useEffect(() => {
    if (!formData.idParcours) return;
    setNiveaux([]);
    setFormData((prev) => ({ ...prev, idNiveau: null }));

    const fetchNiveaux = async () => {
      const data = await nivService.getNiveauxByParcours(formData.idParcours);
      setNiveaux(data);
    };
    fetchNiveaux();
  }, [formData.idParcours]);

  const handleDownloadTemplate = () => {
    const link = document.createElement("a");
    link.href = "/import_diplomes.csv";
    link.download = "import_diplomes.csv";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const handleFileUpload = (event) => {
    const file = event.files[0];
    const reader = new FileReader();
    reader.onloadend = () => {
      setNomFichier(file.name)
      setFileBase64(reader.result.split(",")[1]);
      setStatus(null);
    };
    reader.readAsDataURL(file);
  };

  const handleSubmit = async () => {
    if (!fileBase64) {
      setStatus({ type: "error", message: "Veuillez sélectionner un fichier CSV." });
      return;
    }

    setLoading(true);
    setStatus(null);

    try {
      const payload = {
        idUniversite : formData.idUniversite,
        idDepartement : formData.idDepartement,
        idParcours : formData.idParcours,
        idNiveau : formData.idNiveau,
        idAnneeAcademique : formData.idAnneeAcademique,
        libelleDiplome : formData.libelleDiplome,
        nomFichier : nomFichier,
        fichier : fileBase64
      }
    
      console.log(payload)
      const result = await chargementService.chargerEtudiants(payload).then(data => {
        console.log(data)
        setStatus({ type: "success", message: "✅ Chargement effectué avec succès !" });
      })
      .catch(error => {
        console.log(error)
        setStatus({
          type: "error",
          message: result.message || "❌ Erreur lors du chargement."
        });
      })

    } catch (error) {
      console.log(error.response)
      console.log(error)
      setStatus({ type: "error", message: "Erreur de connexion au serveur." });
    } finally {
      setLoading(false);
    }
  };

  if (loadingData) {
    return (
      <div className="flex justify-content-center align-items-center h-screen">
        <ProgressSpinner />
      </div>
    );
  }

  return (
    <div className="flex justify-content-center mt-5">
      <Card title="Chargement des étudiants" style={{ width: "650px", textAlign: "center" }}>
        <p className="text-500 mb-4">
          Téléchargez le modèle CSV, remplissez-le, puis sélectionnez-le pour le chargement.
        </p>

        <Button
          label="Télécharger le modèle CSV"
          icon="pi pi-download"
          className="p-button-sm p-button-outlined mb-4"
          onClick={handleDownloadTemplate}
        />
        {role_admin ?
        <div className="grid p-fluid text-left">
          <div className="col-6 mb-3">
            <Dropdown
              value={formData.idUniversite}
              options={universites}
              optionLabel="nomUniversite"
              optionValue="idUniv"
              onChange={(e) => setFormData({ ...formData, idUniversite: e.value })}
              placeholder="Université"
              filter
            />
          </div>
           
          <div className="col-6 mb-3">
            <Dropdown
              value={formData.idEtablissement}
              options={etablissements}
              optionLabel="nom"
              optionValue="idEtablissement"
              onChange={(e) => setFormData({ ...formData, idEtablissement: e.value })}
              placeholder="Établissement"
              disabled={!formData.idUniversite}
            />
          </div>

          <div className="col-6 mb-3">
            <Dropdown
              value={formData.idDepartement}
              options={departements}
              optionLabel="lbDepartementEtab"
              optionValue="idDepartement"
              onChange={(e) => setFormData({ ...formData, idDepartement: e.value })}
              placeholder="Département"
              disabled={!formData.idEtablissement}
            />
          </div>

          <div className="col-6 mb-3">
            <Dropdown
              value={formData.idParcours}
              options={parcours}
              optionLabel="libelleParcours"
              optionValue="idParcours"
              onChange={(e) => setFormData({ ...formData, idParcours: e.value })}
              placeholder="Parcours"
              disabled={!formData.idDepartement}
            />
          </div>

          <div className="col-6 mb-3">
            <Dropdown
              value={formData.idNiveau}
              options={niveaux}
              optionLabel="libelleNiveau"
              optionValue="idNiveau"
              onChange={(e) => setFormData({ ...formData, idNiveau: e.value })}
              placeholder="Niveau"
              disabled={!formData.idParcours}
            />
          </div>

          <div className="col-6 mb-3">
            <Dropdown
              value={formData.idAnneeAcademique}
              options={annees}
              optionLabel="libelleAnnee"
              optionValue="idAnnee"
              onChange={(e) => setFormData({ ...formData, idAnneeAcademique: e.value })}
              placeholder="Année académique"
              filter
            />
          </div>

          <div className="col-12 mb-4">
            <span className="p-float-label">
              <InputText
                id="libelleDiplome"
                value={formData.libelleDiplome}
                onChange={(e) =>
                  setFormData({ ...formData, libelleDiplome: e.target.value })
                }
                className="w-full"
              />
              <label htmlFor="libelleDiplome">Libellé du diplôme</label>
            </span>
          </div>
        </div>
          :
        <div className="grid p-fluid text-left">
          <div className="col-6 mb-3">
            <Dropdown
              value={formData.idEtablissement}
              options={etablissements}
              optionLabel="nom"
              optionValue="idEtablissement"
              onChange={(e) => setFormData({ ...formData, idEtablissement: e.value })}
              placeholder="Établissement"
              disabled={!formData.idUniversite}
            />
          </div>
          <div className="col-6 mb-3">
            <Dropdown
              value={formData.idDepartement}
              options={departements}
              optionLabel="lbDepartementEtab"
              optionValue="idDepartement"
              onChange={(e) => setFormData({ ...formData, idDepartement: e.value })}
              placeholder="Département"
              disabled={!formData.idEtablissement}
            />
          </div>

          <div className="col-6 mb-3">
            <Dropdown
              value={formData.idParcours}
              options={parcours}
              optionLabel="libelleParcours"
              optionValue="idParcours"
              onChange={(e) => setFormData({ ...formData, idParcours: e.value })}
              placeholder="Parcours"
              disabled={!formData.idDepartement}
            />
          </div>

          <div className="col-6 mb-3">
            <Dropdown
              value={formData.idNiveau}
              options={niveaux}
              optionLabel="libelleNiveau"
              optionValue="idNiveau"
              onChange={(e) => setFormData({ ...formData, idNiveau: e.value })}
              placeholder="Niveau"
              disabled={!formData.idParcours}
            />
          </div>

          <div className="col-6 mb-3">
            <Dropdown
              value={formData.idAnneeAcademique}
              options={annees}
              optionLabel="libelleAnnee"
              optionValue="idAnnee"
              onChange={(e) => setFormData({ ...formData, idAnneeAcademique: e.value })}
              placeholder="Année académique"
              filter
            />
          </div>

          <div className="col-6 mb-3">
            <span className="p-float-label">
              <InputText
                id="libelleDiplome"
                value={formData.libelleDiplome}
                onChange={(e) =>
                  setFormData({ ...formData, libelleDiplome: e.target.value })
                }
                className="w-full"
              />
              <label htmlFor="libelleDiplome">Libellé du diplôme</label>
            </span>
          </div>
        </div>
        }

        <FileUpload
          mode="basic"
          name="csv"
          accept=".csv"
          chooseLabel="Selectionner..."
          auto={false}
          customUpload
          uploadHandler={handleFileUpload}
          onSelect={handleFileUpload}
        />

        <div className="mt-4">
          <Button
            label="Charger le fichier"
            icon="pi pi-upload"
            className="p-button-success"
            onClick={handleSubmit}
            disabled={loading}
          />
        </div>

        <div className="mt-4">
          {loading && <ProgressSpinner style={{ width: "50px", height: "50px" }} />}
          {status && (
            <Message
              severity={status.type === "success" ? "success" : "error"}
              text={status.message}
            />
          )}
        </div>
      </Card>
    </div>
  );
}

export default ChargementEtudiants;
